import React from 'react'
import PropTypes from 'prop-types'
import { rem } from 'polished'
import styled from 'styled-components'
import LinkedIn from 'images/svg/linkedin.svg'
import Twitter from 'images/svg/twitter.svg'
import { COLOR, FONT_SIZE, RADIUS, SPACE } from 'Theme'
import { Box, Flex } from 'components/Layout'

const IMAGE_SIZE = rem(36)

const SOCIAL_NETWORKS = {
  TWITTER: 'twitter',
  LINKEDIN: 'linkedin',
}

const ICON_COMPONENTS = {
  [SOCIAL_NETWORKS.TWITTER]: Twitter,
  [SOCIAL_NETWORKS.LINKEDIN]: LinkedIn,
}

const ImageWrapper = styled('div')`
  overflow: hidden;

  width: ${IMAGE_SIZE};
  height: ${IMAGE_SIZE};

  border-radius: ${RADIUS.CIRCLE};
`

const Profile = styled('div')`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: ${SPACE.S};
  align-items: center;

  margin: ${SPACE.L} 0;
  padding: ${SPACE.XM} 0;

  font-size: ${FONT_SIZE.XS};
  text-transform: uppercase;
  letter-spacing: 0.07em;

  border: solid ${COLOR.SQUANT};
  border-width: 1px 0;
`

const SocialLink = styled('a')`
  display: flex;

  margin-left: ${SPACE.XS};
  padding: ${SPACE.S};
`

const SocialIcon = styled('img')`
  display: block;

  width: ${rem(22)};
  height: ${rem(22)};
  margin: auto;

  color: ${COLOR.BLACK};
`

const ProfileBlock = ({ name, avatar, socialNetworks }) => {
  const filteredSocialNetworks = Object.entries(
    socialNetworks
  ).filter(([, value]) => Boolean(value))

  return (
    <Profile>
      <ImageWrapper>{avatar}</ImageWrapper>
      <Box>
        <small>napísal</small>
        <p>{name}</p>
      </Box>
      {filteredSocialNetworks && (
        <Flex alignItems="center" px={SPACE.M}>
          {filteredSocialNetworks.map(([network, url]) =>
            SOCIAL_NETWORKS[network.toUpperCase()] ? (
              <SocialLink
                key={url}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${network}-icon`}
              >
                <SocialIcon src={ICON_COMPONENTS[network]} />
              </SocialLink>
            ) : null
          )}
        </Flex>
      )}
    </Profile>
  )
}

ProfileBlock.propTypes = {
  name: PropTypes.string.isRequired,
  avatar: PropTypes.node.isRequired,
  socialNetworks: PropTypes.shape({
    twitter: PropTypes.string,
    linkedin: PropTypes.string,
  }).isRequired,
}

export default ProfileBlock
